import { PrintButton } from "../Printer/checklist/PrintButton"
import { Action } from "../../../ui/Action"
import { PrinterIcon } from "lucide-react"
import {useMerchant} from "../../../../store/global/useMerchant";

export function ChecklistPrint({ onClick: callbackFn = () => { }, beforeClick = () => { }, token, ...rest }) {
  const merchant = useMerchant(st=>st.data.merchant)

  const browserPrinter = !!merchant?.activeModules?.['impressora-bandt']
  const printerAssistent = !!merchant?.activeModules?.['impressora-bandt-v2']

  const ChecklistPrintButton = printerAssistent ? PrintButton : Action.Root;

  if (!browserPrinter && !printerAssistent) return null

  const printAction = () => {
    if (browserPrinter && !printerAssistent) {
      window.open(
        `https://printer.petlandbrasil.com.br/?token=${token}`,
        'popup',
        'width=350, height=255, top=100, left=110, scrollbars=no',
      );
    }
    callbackFn();
  }

  return (
    <ChecklistPrintButton {...rest} beforeClick={beforeClick} onClick={printAction}>
      <Action.Icon icon={PrinterIcon} />
      IMPRIMIR CHECKLIST
    </ChecklistPrintButton>
  )
}
